<template>

  <el-card v-loading="isLoading">
    <div slot="header" class="clearfix">
      <el-col :md="12">
        <span class="cadastro-title"> Respostas para a Competência</span>
      </el-col>
      <el-col :md=12 align="right">
        <el-select v-model="seederSelected" placeholder="Selecione o Seeder">
          <el-option
            v-for="item in seedersLean"
            :value-key="item.id"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </div>
    <div v-if="seeders && seederSelecionado">
      <el-row>
        <transition name="fade" mode="out-in">
          <div v-show="! centroCustoSelectedId">
            <el-col :xs="24" :md="24">
              <div style="height: 2em;">
                <el-progress  :text-inside="true" :stroke-width="20"  :percentage="seederSelecionado.progresso"
                              :status="seederSelecionado.progresso >= 100 ? 'success' : 'exception'"></el-progress>
              </div>
            </el-col>
            <el-col :xs="24" :md="24">
              <progress-list :lista="dadosSelecionados" :selected.sync="centroCustoSelectedId"></progress-list>
            </el-col>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <el-col :xs="24" :md="24" v-if="centroSelecionado" v-show="centroSelecionado">
            <resposta-list :centrocusto="centroSelecionado" :centrocustoid.sync="centroCustoSelectedId"></resposta-list>
          </el-col>
        </transition>
      </el-row>
    </div>
  </el-card>
</template>

<script>

  import ProgressList from './ProgressList'
  import RespostaList from './RespostaList'
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    name: "seeder-index",
    components: {ProgressList, RespostaList},
    data() {
      return {
        isLoading: false,
        seederSelected: null,
        centroCustoSelectedId: null
      }
    },
    computed: {
      ...mapGetters('Seeder', ['seedersLean']),
      ...mapState('Seeder', ['seeders', 'shouldReload']),
      seederSelecionado() {
        if (! this.seeders) {
          return {centrocustos: [], progresso: 0}
        }
        return this.seeders[this.seederSelected]
      },
      dadosSelecionados() {
        return collect(this.seederSelecionado.centrocustos).toArray()
      },
      centroSelecionado() {
        if (!this.centroCustoSelectedId) {
          return null
        }
        const {centrocustos: {[this.centroCustoSelectedId]: centroCusto} = null} = this.seederSelecionado
        return centroCusto
      }
    },
    methods: {
      ...mapActions('Seeder', ['SET_SEEDERS', 'SET_RESPOSTAS']),
      async load() {
        this.isLoading = true
        await this.SET_SEEDERS()
        if (this.seederSelected === null) {
          this.seederSelected = this.seeders ?  parseInt(Object.keys(this.seeders)[0]) : null
        }
        this.isLoading = false
      }
    },
    async mounted() {
      await this.load()
    },
    watch: {
      shouldReload: function (newState, oldState) {
        if (newState === true) {
          this.load()
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Seeder/index.vue